import React, { useState } from "react";
import Header from "../Header/HeaderComponent";
import "../../assets/css/registerPdpa.css";
import { MoonLoader } from "react-spinners";
import { useTranslation } from "react-i18next";

const FormPdpa = ({ onAgree, loading, header = true }) => {
  const [isChecked, setIsChecked] = useState(false);
  const { t } = useTranslation("register");
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div id="PagePdpa">
      {header && (
        <>
          <Header
            title={t("acceptAgreement")}
            onBack={false}
            showRightMenu={false}
          />
        </>
      )}
      <div className="wrapContent">
        <div id="pPdpa">
          <div className="bContent">
            <div className="bContext" style={{ fontSize: "14px", lineHeight: 1.8, color: "#333" }}>
              <div dangerouslySetInnerHTML={{ __html: t("agreement") }} />
            </div>

            <footer className="footer">
              <div className="pdpaButton">
                <div
                  className="checkbox-container"
                  style={{ width: "100%", maxWidth: "600px", margin: "auto" }}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label>{t("acceptPdpa")}</label>
                </div>
                <button
                  style={{ width: "100%", maxWidth: "600px", margin: "auto" }}
                  type="button"
                  onClick={onAgree}
                  disabled={!isChecked || loading}
                  className={isChecked ? "" : "disable"}
                >
                  {loading ? (
                    <MoonLoader size={20} color="#065f4f" loading={loading} />
                  ) : (
                    <>{t("accept")}</>
                  )}
                </button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormPdpa;
